import { useShare } from '../hooks/useShare';
import Twitter from '../icons/twitter';
import Facebook from '../icons/facebook';
import Pinterest from '../icons/pinterest';
import WhatsApp from '../icons/whatsapp';

type ShareButtonProps = { social?: string };

const ShareButton = ({ social }: ShareButtonProps) => {
	const { options } = useShare();

	return (
		<button
			aria-label="twitter"
			className="shareSocialButton shareSocialButton--twitter react-share__ShareButton vtex-store-components-3-x-shareSocialButton vtex-store-components-3-x-shareSocialButton--twitter mh1 pointer outline-0 dim"
			style={{
				backgroundColor: 'transparent',
				border: 'none',
				padding: '0px',
				font: 'inherit',
				color: 'inherit',
				cursor: 'pointer',
			}}
		>
			<svg
				viewBox="0 0 64 64"
				width={options?.size}
				height={options?.size}
				className="shareSocialIcon shareSocialIcon--twitter vtex-store-components-3-x-shareSocialIcon vtex-store-components-3-x-shareSocialIcon--twitter"
			>
				{social === 'Facebook' && <Facebook />}
				{social === 'Pinterest' && <Pinterest />}
				{social === 'WhatsApp' && <WhatsApp />}
				{social === 'Twitter' && <Twitter />}
			</svg>
		</button>
	);
};

export default ShareButton;
